<template>
  <div
    class="list-container"
  >
    <!--下拉刷新-->
    <van-pull-refresh
      v-model="refreshing"
      class="list-wrapper"
      @refresh="handleRefresh"
      @scroll.native="handleScroll"
    >
      <!--列表-->
      <van-list
        v-model="loading"
        :finished="finished"
        :error.sync="error"
        :offset="100"
        finished-text="没有更多了"
        error-text="请求失败，点击重新加载"
        @load="handleLoad"
      >
        <!--申请列表项-->
        <application-list-item
          v-for="item in items"
          :key="item.id"
          :application-info="item"
        />
      </van-list>
    </van-pull-refresh>
    <!--侧边栏-->
    <div v-show="scrollPageNumber > 1" class="block-sidebar">
      <!--置顶-->
      <van-icon
        name="top"
        class="block-sidebar-item top"
        color="#fff"
        size="24px"
        class-prefix="iconfont"
        @click="scrollToTop(true)"
      />
      <!--分页-->
      <div class="block-sidebar-item pagination">
        <div class="page-number">
          {{ scrollPageNumber }}
        </div>
        <div class="page-count">
          {{ pageCount }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { scrollToTop } from '@/utils'
import { getApplicationInfoPagedList } from '@/api/application'
import ApplicationListItem from './ApplicationListItem'

export default {
  components: {
    ApplicationListItem
  },
  props: {
    pageSize: {
      type: Number,
      default: 20
    },
    status: {
      type: String,
      default: ''
    },
    keyword: {
      type: String,
      default: ''
    },
    height: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      refreshing: false,
      loading: false,
      finished: false,
      error: false,
      pageNumber: 0,
      pageCount: 0,
      items: [],
      scrollTop: 0
    }
  },
  computed: {
    ...mapGetters(['webUserInfo']),
    defaultQueryParams: function() {
      return {
        pageSize: this.pageSize,
        applicantId: this.webUserInfo.id,
        status: this.status
      }
    },
    scrollPageNumber: function() {
      const scrollTop = this.scrollTop
      let scrollIndex = 0
      if (this.$el) {
        const elements = this.$el.querySelectorAll('.application-list-item')
        for (let offsetTop = 0; offsetTop <= scrollTop; scrollIndex++) {
          offsetTop += elements[scrollIndex].clientHeight// + 10
        }
      }
      if (scrollIndex % this.pageSize === 0) {
        return parseInt(scrollIndex / this.pageSize)
      } else {
        return parseInt(scrollIndex / this.pageSize) + 1
      }
    },
    wrapper: function() {
      return this.$el.querySelector('.list-wrapper')
    }
  },
  created() {

  },
  mounted() {
    // 设置列表高度
    if (this.height > 0) {
      this.wrapper.style.height = this.height + 'px'
    }
  },
  activated() {
    // 恢复垂直滚动位置
    this.wrapper.scrollTop = this.scrollTop
  },
  methods: {
    // 滚动至顶部
    scrollToTop(animated) {
      if (animated) {
        scrollToTop(this.wrapper, 0, 200)
      } else {
        this.wrapper.scrollTop = 0
      }
    },
    // 处理滚动事件
    handleScroll(event) {
      this.scrollTop = event.target.scrollTop
    },
    // 刷新列表
    refresh() {
      this.handleRefresh()
    },
    // 处理列表加载事件
    handleLoad() {
      this.loading = true
      this.loadData(this.pageNumber + 1).then(data => {
        this.items = this.items.concat(data.items)
        this.finished = this.items.length === data.totalItemCount
        this.$emit('load', data)
      }).finally(() => {
        this.loading = false
      })
    },
    // 处理列表刷新事件
    handleRefresh() {
      this.refreshing = true
      this.loadData(1).then(data => {
        this.items = data.items
        this.finished = this.items.length === data.totalItemCount
        this.$emit('refresh', data)
      }).finally(() => {
        this.refreshing = false
      })
    },
    // 加载列表数据
    loadData(pageNumber) {
      return new Promise((resolve, reject) => {
        const queryParams = Object.assign({}, this.defaultQueryParams, { pageNumber })
        getApplicationInfoPagedList(queryParams).then(({ data }) => {
          this.pageNumber = data.pageNumber
          this.pageCount = data.pageCount
          resolve(data)
        }).catch(error => {
          // 设置列表加载失败
          this.error = true
          reject(error)
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.list-container{
  position: relative;
  .list-wrapper{
    overflow-y: auto;
    background-color: #eee;
  }
  .list-wrapper::-webkit-scrollbar {
    display: none;
  }
  .block-sidebar {
    position: absolute;
    right: 20px;
    bottom: 20px;
    z-index: 1000;
    .block-sidebar-item {
      display: block;
      width: 40px;
      height: 40px;
      margin-bottom: 10px;
      border-radius: 20px;
      color: #fff;
      background-color: rgba(204, 204, 204, 0.5);
      text-align: center;
    }
    .block-sidebar-item.top {
      line-height: 40px;
    }
    .block-sidebar-item.pagination {
      line-height: 20px;
      font-size: 12px;
      .page-number {
        width: 30px;
        margin: 0 auto;
        font-weight: 700;
      }
      .page-count {
        width: 30px;
        margin: 0 auto;
        border-top: 1px solid #fff;
      }
    }
  }
}
</style>
